<template>
	<dialog-window :moveable="false" :resizable="false" ref="confirmDialog" show="modal" :width="400" @close="closedEvent">
		<template #default>
			<div class="confirm-icn-msg">
				<sym-icon :name="icon" class="confirm-icn" :style="{ color: iconColor }"></sym-icon>
				<div class="confirm-msg">{{ message }}</div>
			</div>
		</template>
		<template #controls>
			<div class="confirm-buttons">
				<button type="button" class="sbutton" @click="actionNo">{{ no }}</button>
				<button type="button" class="button" @click="actionYes">{{ yes }}</button>
			</div>
		</template>
	</dialog-window>
</template>

<script setup lang="ts">
import {ref, computed} from "vue";
import DialogWindow from "@/dialog/DialogWindow.vue";
import SymIcon from "@fd/helpers/SymIcon.vue";
import {injectEnv} from "@fd/Environment.ts";

const props = withDefaults(defineProps<{
	icon?: string;
	iconColor?: string;
	message: string;
	yesLabel?: string;
	noLabel?: string;
}>(), {
	icon: "warning-18",
	iconColor: "var(--orange)"
});
const emit = defineEmits(["yes", "no"]);
const env = injectEnv();

const confirmDialog = ref(null);

const yes = computed<string>(() => {
	if (props.yesLabel) return props.yesLabel;
	return env.msg("bas.yes");
});

const no = computed<string>(() => {
	if (props.noLabel) return props.noLabel;
	return env.msg("bas.no");
});

function closedEvent() {
	actionNo();
}

function actionNo() {
	emit("no");
}

function actionYes() {
	emit("yes");
}

</script>

<style>
.confirm-buttons {
	display: flex;
	flex-direction: row;
	column-gap: 16px;
	align-items: baseline;
}
.confirm-icn-msg {
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	column-gap: 16px;
}
.confirm-icn {
	font-size: 42px;
}
.confirm-msg {
	max-width: 20em;
	line-height: 1.5;
	font-size: 16px;
}
</style>